const OrderDetail = ({ onClose, refetch, id }: { onClose: any; refetch: any; id: any }) => {
  return <></>;
};
export default OrderDetail;
